import { runTransaction, doc, } from "firebase/firestore";
import { FirebaseUtils } from './FirebaseUtils.js';

import { gApp, DebugOn } from '../Globals.js'

export class ProjectLock {
  static async acquireLock(projId) {
    // Note: caller should do ownership check before this
    console.log(`Acquiring lock ${projId}`);
    let fbUtils = new FirebaseUtils(gApp.getUser());
    await fbUtils.setDoc(doc(gApp.db, 'locks', projId), {
      userEmail: gApp.getUser().email,
      time: Date.now(),
    }, 'acquire-lock');
  }

  static async forceAcquireLock(projId) {
    // Note: acquireLock is already force-acquire for now
    await this.acquireLock(projId);
  }

  /*
  Returns the current lock owner.
  */
  static async updateOwnership(projId) {
    // console.log("Updating lock ownership...");
    let fbUtils = new FirebaseUtils(gApp.getUser());
    let docRef = doc(gApp.db, 'locks', projId);
    let userEmail = gApp.getUser().email;

    // Use a plain read + write instead of a transaction to avoid FAILED_PRECONDITION
    // errors when multiple tabs from the same user run concurrent transactions on the
    // same lock document. The 5-second lock expiry is the real safety net here.
    const lockDoc = await fbUtils.getDoc(docRef, 'get-lock-ownership');
    if (!lockDoc.exists()) {
      console.log("Lock not found. Acquiring lock");
      await fbUtils.setDoc(docRef, { userEmail, time: Date.now() }, 'reacquire-lock');
      return userEmail;
    }
    const ownerEmail = lockDoc.data().userEmail;
    if (ownerEmail !== userEmail) {
      console.log("We no longer have the lock. Possibly stolen.");
      return ownerEmail;
    }
    // We still own it — refresh the timestamp
    await fbUtils.setDoc(docRef, { userEmail, time: Date.now() }, 'update-lock-ownership');
    return userEmail;
  }

  static async tryReleaseLock(projId) {
    // This only releases if we have the lock
    console.log(`Releasing lock ${projId}...`)
    let docRef = doc(gApp.db, 'locks', projId);
    await runTransaction(gApp.db, async (transaction) => {
      const lockDoc = await transaction.get(docRef);
      if (!lockDoc.exists()) {
        console.log("Already released");
        return;
      }
      if (lockDoc.data().userEmail !== gApp.getUser().email) {
        console.log("No longer owned by us. Not releasing.");
        return;
      }
      console.log(`Deleting lock ${projId}`)
      transaction.delete(docRef);
    });
  }

  static async _getLockData(projId) {
    let fbUtils = new FirebaseUtils(gApp.getUser());
    let docSnap = await fbUtils.getDoc(doc(gApp.db, 'locks', projId), 'get-lock-data');
    if (!docSnap.exists()) {
      return null;
    }
    return docSnap.data();
  }

  static async getLockOwner(projId) {
    // We consider a lock 'valid' if it exists and it is not expired (old timestamp)
    let lockData = await this._getLockData(projId);
    let curTime = Date.now();
    if (!lockData || (curTime - lockData.time) > 5000) {
      return null;
    }
    return lockData.userEmail;
  }

  // Does the local user have the proj lock?
  static async hasLock(projId) {
    let owner = await this.getLockOwner(projId);
    return owner && owner == gApp.getUser().email;
  }

  static async canOpen(projId) {
    let owner = await this.getLockOwner(projId);
    let canOpen = !owner || owner == gApp.getUser().email;
    console.log(`Can open proj ${projId}? ${canOpen} (owner: ${owner})`);
    return canOpen;
  }
};